import { StyleSheet, Platform } from 'react-native';

const typesColors = theme => ({
  active: theme.colors.cardBackgroundColor,
  expired: theme.colors.cardBackgroundColorTwo,
  renewable: 'transparent',
});

const shadow = {
  elevation: 1,
  shadowColor: 'rgba(0, 0, 0, 0.16)',
  shadowOffset: {
    width: 0,
    height: 2,
  },
  shadowRadius: 4,
  shadowOpacity: 1,
};

export default StyleSheet.create({
  cardContainer: type => ({
    justifyContent: 'center',
    position: 'absolute',
    borderRadius: 6.2,
    zIndex: 1,
    opacity: type === 'expired' ? (Platform.OS === 'android' ? 0.3 : 0.5) : 1,
    paddingBottom: 4,
    paddingTop: 8,
  }),
  card: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  cardPosition: (width, height, top, left, fullWidth, type, theme) => ({
    width: fullWidth ? width : 'auto',
    height,
    top,
    left,
    backgroundColor: fullWidth ? typesColors(theme)[type] : 'transparent',
    borderWidth: type === 'renewable' && fullWidth ? 0.8 : 0,
    borderColor: 'rgb(153, 153, 153)',
  }),
  iconWrapper: (type, theme, fullWidth, width) => ({
    paddingVertical: 12,
    paddingHorizontal: 8,
    backgroundColor: fullWidth ? 'transparent' : typesColors(theme)[type],
    borderRadius: fullWidth ? 0 : 6.2,
    width: !fullWidth ? width : 'auto',
    borderWidth: type === 'renewable' && !fullWidth ? 0.8 : 0,
    borderColor: 'rgb(153, 153, 153)',
    marginRight: 5,
  }),
  cardShadow: {
    ...shadow,
  },
  fullWidth: (type, theme) => ({
    backgroundColor: typesColors(theme)[type],
    ...shadow,
  }),
  textWrapper: {
    flex: 0.5,
    flexBasis: 100,
  },
  name: {
    fontWeight: 'bold',
  },
  price: theme => ({
    paddingVertical: 4,
    color: theme.colors.activeTabColor,
  }),
});
